import React, { forwardRef } from 'react';
import { Spin, Typography } from 'antd';

const { Text } = Typography;

interface LoadMoreTriggerProps {
  hasNext: boolean;
  isLoading: boolean;
  onLoadMore: () => void;
}

export const LoadMoreTrigger = forwardRef<HTMLDivElement, LoadMoreTriggerProps>(
  ({ hasNext, isLoading, onLoadMore }, ref) => {
    if (!hasNext) return null;

    return (
      <div className="load-more-trigger" ref={ref}>
        {isLoading && (
          <div className="loading-indicator">
            <Spin size="small" />
            <Text className="loading-text">
              Loading more messages...
            </Text>
          </div>
        )}
      </div>
    );
  }
);

LoadMoreTrigger.displayName = 'LoadMoreTrigger';
